/** 根据token是否存在判断是否登录 */
export function isLogin() {
  const token = localStorage.getItem('token');
  return !token ? false : true;
}

/** 存token */
export function setToken(token: any) {
  sessionStorage.setItem('token', token);
}

/** 取token */
export function getToken() {
  return sessionStorage.getItem('token');
}

/** 清除token */
export function clearToken() {
  sessionStorage.removeItem('token');
}

/** 存用户名 */
export function setUserName(name: any) {
  sessionStorage.setItem('username', name);
}
/** 取用户名 */
export function getUserName() {
  return sessionStorage.getItem('username');
}

/** 清除用户名 */
export function clearUserName() {
  sessionStorage.removeItem('username');
}
/** 登出时清除用户名、token */
export function logout(isInitiative?: boolean) {
  clearUserName();
  clearToken();
  let loginUrl = '/login';
  // 是否是主动点击退出登录
  if (!isInitiative) {
    const pathname = window.location.pathname;
    loginUrl += '?redirectUrl=' + pathname;
  }
  window.location.href = loginUrl;
}

const whiteList = ['/login', '/examine', /\/confirm_exam\/\w+/, '/result_exam', '/examination', '/examinee_answers'];
/** 判断是否跳转登陆页面 */
export function judgeAuthority(to: any) {
  const hasAccess = whiteList.some(i => (typeof i === 'string' ? i === to : i.test(to)));
  if (getToken()) {
    return true;
  } else if (hasAccess) {
    return true;
  } else {
    return false;
  }
}

/** 取cookie */
export function getCookie(cname: any) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/**
 * 设置localstorage值
 * @param key
 * @param value
 */
export function setLocalKey(key: string, value: string) {
  localStorage.setItem(key, value);
}

/**
 * 获取localstorage值
 * @param param 需要获取值的key
 */
export function getLocalValue(param: string) {
  return localStorage.getItem(param);
}

/**
 * 清除localstorage值
 * @param param 需要清除的key
 */
export function clearLocalKey(param: string) {
  localStorage.removeItem(param);
}
